/**
 * HEIGHTN — Size Converter (EU / UK / US)
 * - Default mode: EU
 * - Toggle in legend's upper-right
 * - On mode change, variant labels switch to UK/US equivalent
 * - On add-to-cart, adds line-item property "UK Size" or "US Size"
 *   so it shows in cart/checkout
 */
(function () {
  'use strict';
  if (window.__heightnSizeConverter) return;
  window.__heightnSizeConverter = true;

  // ─── Conversion table ──────────────────────────────────────────
  var SIZE_MAP = {
    'EU 37':   { uk: 'UK 4.5',  us: 'US 5.5' },
    'EU 41.5': { uk: 'UK 7.5',  us: 'US 8.5' },
    'EU 43.5': { uk: 'UK 9',    us: 'US 10' },
    'EU 38':   { uk: 'UK 5',    us: 'US 6' },
    'EU 39':   { uk: 'UK 5.5',  us: 'US 6.5' },
    'EU 40':   { uk: 'UK 6',    us: 'US 7' },
    'EU 40.5': { uk: 'UK 6.5',  us: 'US 7.5' },
    'EU 41':   { uk: 'UK 7',    us: 'US 8' },
    'EU 42':   { uk: 'UK 7.5',  us: 'US 8.5' },
    'EU 42.5': { uk: 'UK 8',    us: 'US 9' },
    'EU 43':   { uk: 'UK 8.5',  us: 'US 9.5' },
    'EU 44':   { uk: 'UK 9',    us: 'US 10' },
    'EU 44.5': { uk: 'UK 9.5',  us: 'US 10.5' },
    'EU 45':   { uk: 'UK 10',   us: 'US 11' },
    'EU 45.5': { uk: 'UK 10.5', us: 'US 11.5' },
    'EU 46':   { uk: 'UK 11',   us: 'US 12' },
    'EU 47':   { uk: 'UK 12',   us: 'US 13' },
    'EU 47.5': { uk: 'UK 12.5', us: 'US 13.5' }
  };

  // ─── Mode (persisted in sessionStorage) ─────────────────────────
  var mode = sessionStorage.getItem('sc-mode') || 'EU';
  function setMode(m) { mode = m; sessionStorage.setItem('sc-mode', m); }
  window.__scGetMode = function () { return mode; };
  window.__scApplyAll = function () { applyAll(); };

  // ─── Styles ─────────────────────────────────────────────────────
  function injectCss() {
    if (document.getElementById('sc-styles')) return;
    var s = document.createElement('style');
    s.id = 'sc-styles';
    s.textContent = [
      /* Preserve variant grid (was previously in size-converter v1) */
      'fieldset.variant-option--buttons{display:grid !important;grid-template-columns:repeat(5,1fr) !important;gap:5px !important}',
      'fieldset.variant-option--buttons legend{grid-column:1/-1 !important;display:flex !important;justify-content:space-between !important;align-items:center !important;width:100% !important;margin-bottom:8px !important;gap:8px}',
      '.variant-option__button-label{min-width:unset !important;width:100% !important;height:36px !important;padding:0 !important;margin:0 !important;display:flex !important;align-items:center !important;justify-content:center !important;border:0.8px solid #d0d0d0 !important;border-radius:var(--style-border-radius-buttons-primary) !important;background:#fff !important;cursor:pointer !important;box-shadow:none !important}',
      '.variant-option__button-label__text{font-size:12px !important;font-weight:500 !important;color:#222 !important;line-height:1 !important}',
      '.variant-option__button-label:has(input:checked){background:#111 !important;border-color:#111 !important}',
      '.variant-option__button-label:has(input:checked) .variant-option__button-label__text{color:#fff !important}',
      '.variant-option__button-label:has(input[data-option-available="false"]){background:#f5f5f5 !important;border-color:#e5e5e5 !important;cursor:default !important}',
      '.variant-option__button-label:has(input[data-option-available="false"]) .variant-option__button-label__text{color:#b0b0b0 !important;text-decoration:line-through !important}',

      /* Toggle */
      '.sc-toggle{display:inline-flex;gap:2px;flex-shrink:0;order:2}',
      '.sc-btn{padding:3px 8px;border:0.8px solid #000;background:transparent;color:#000 !important;cursor:pointer;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;line-height:1.5;opacity:.4;border-radius:3px;font-family:inherit;-webkit-appearance:none;appearance:none;transition:opacity .15s,background .15s}',
      '.sc-btn:hover{opacity:.7}',
      '.sc-btn.sc-active{opacity:1;background:#000 !important;color:#fff !important;border-color:#000}',

      /* Position the size-chart link to the left of the toggle */
      '.hg-sg-link{order:1;margin-left:auto !important}'
    ].join('');
    document.head.appendChild(s);
  }

  // ─── Helpers ────────────────────────────────────────────────────
  function getDisplayValue(euVal) {
    var conv = SIZE_MAP[euVal];
    if (!conv) return euVal;
    if (mode === 'UK') return conv.uk;
    if (mode === 'US') return conv.us;
    return euVal;
  }

  function getForm(picker) {
    var parent = picker.closest('product-form-component') || document.querySelector('product-form-component');
    return parent ? parent.querySelector('form') : null;
  }

  function setProp(form, name, value) {
    var inp = form.querySelector('[name="properties[' + name + ']"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'properties[' + name + ']';
      form.appendChild(inp);
    }
    inp.value = value;
  }
  function clearProp(form, name) {
    var inp = form.querySelector('[name="properties[' + name + ']"]');
    if (inp) inp.remove();
  }

  // ─── Apply mode to one variant-picker ───────────────────────────
  function applyPicker(picker) {
    /* 1 · Update label text for each size option */
    picker.querySelectorAll('[data-key="variant-option-text"]').forEach(function (span) {
      var current = span.textContent.trim();

      /* Save the original EU value if not yet stored */
      if (!span.dataset.euVal && /^EU\s?\d/.test(current)) {
        span.dataset.euVal = current;
      }

      var euVal = span.dataset.euVal;
      if (!euVal) return;

      var newDisplay = getDisplayValue(euVal);
      if (span.textContent.trim() !== newDisplay) {
        span.textContent = newDisplay;
      }
    });

    /* 2 · Update cart line-item property based on selected variant */
    var form = getForm(picker);
    if (form) {
      /* Always clear both to start */
      clearProp(form, 'UK Size');
      clearProp(form, 'US Size');

      if (mode !== 'EU') {
        var selected = picker.querySelector('input[type="radio"]:checked');
        if (selected) {
          /* The radio value should match an EU key in SIZE_MAP */
          var euVal = selected.value;
          /* Sometimes the value is stored without the space (e.g. "EU38") */
          if (!SIZE_MAP[euVal]) {
            var normalized = euVal.replace(/^EU(\d)/, 'EU $1');
            if (SIZE_MAP[normalized]) euVal = normalized;
          }
          var conv = SIZE_MAP[euVal];
          if (conv) {
            if (mode === 'UK') setProp(form, 'UK Size', conv.uk);
            if (mode === 'US') setProp(form, 'US Size', conv.us);
          }
        }
      }
    }

    /* 3 · Inject the toggle (re-create if missing) */
    var legend = (function () {
      var ff = picker.querySelectorAll('fieldset.variant-option--buttons');
      for (var i = 0; i < ff.length; i++) {
        var r = ff[i].querySelector('input[type="radio"]');
        if (r && /^Size-/.test(r.name)) return ff[i].querySelector('legend');
      }
      return null;
    })();
    if (!legend) return;

    var tog = legend.querySelector('.sc-toggle');
    if (!tog) {
      tog = document.createElement('span');
      tog.className = 'sc-toggle';
      tog.innerHTML =
        '<button class="sc-btn" data-sc="EU" type="button">EU</button>' +
        '<button class="sc-btn" data-sc="UK" type="button">UK</button>' +
        '<button class="sc-btn" data-sc="US" type="button">US</button>';
      legend.appendChild(tog);

      tog.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-sc]');
        if (!btn || btn.dataset.sc === mode) return;
        setMode(btn.dataset.sc);
        applyAll();
      });
    }

    tog.querySelectorAll('.sc-btn').forEach(function (b) {
      b.classList.toggle('sc-active', b.dataset.sc === mode);
    });
  }

  function applyAll() {
    document.querySelectorAll('variant-picker').forEach(applyPicker);
  }

  // ─── Radio change → re-apply (mainly for cart prop) ─────────────
  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="radio"]')) return;
    var picker = e.target.closest('variant-picker');
    if (picker) requestAnimationFrame(function () { applyPicker(picker); });
  }, true);

  // ─── Re-apply after section re-renders ──────────────────────────
  ['shopify:section:load', 'shopify:section:rerender'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(applyAll, 0); });
  });

  // ─── MutationObserver — catches morphs ──────────────────────────
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { pending = false; applyAll(); });
  }).observe(document.body, { childList: true, subtree: true });

  setInterval(applyAll, 300);

  function init() {
    injectCss();
    applyAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
